/* eslint-disable */
export default {
  noRecords: '找不到最近的記錄。',
} as const;

// @key: @#@"noRecords"@#@ @source: @#@"No recent records found."@#@
